import Card from "@/components/Card";
import Dropdown, { Item } from "@/components/form/Dropdown";
import { getYearBeforeCurrent, months } from "@/utils/date-format";
import React, { useEffect } from "react";
import ProcessedPayDataTable from "./processed-pay-table/ProcessedPayDataTable";
import DataTable from "@/components/ui/DataTable";
import PayRecordsDataTable from "./pay-records-table/PayRecordsDataTable";

function PayRecordsPage() {
  const [monthsOptions, setMonthsOptions] = React.useState<Item[]>([]);
  const [selectedYear, setSelectedYear] = React.useState<string>("");
  const [selectedMonth, setSelectedMonth] = React.useState<string>("");

  const yearOptions: Item[] = getYearBeforeCurrent().map((year) => ({
    label: year.toString(),
    value: year.toString(),
  }));

  useEffect(() => {
    const getMonthOptions = () => {
      let tmpMonthsOptions: Item[] = [];
      if (selectedYear === new Date().getFullYear().toString()) {
        // Get the current month and all months before it
        const currentMonthIndex = new Date().getMonth();
        const monthsBefore: Item[] = months
          .slice(0, currentMonthIndex + 1)
          .map((month) => ({
            label: month,
            value: month,
          }));
        tmpMonthsOptions = monthsBefore;
      } else {
        // Get all months
        tmpMonthsOptions = months.map((month) => ({
          label: month,
          value: month,
        }));
      }
      setMonthsOptions(tmpMonthsOptions);
    };

    getMonthOptions();
  }, [selectedYear]);

  useEffect(() => {
    setSelectedYear(new Date().getFullYear().toString());
    setSelectedMonth(months[new Date().getMonth()]);
  }, []);
  return (
    <div className="flex flex-col h-[100vh] w-full p-4 gap-4">
      <Card>
        <div className="flex gap-2 w-full flex-col p-5">
          <div className="font-bold text-2xl mb-4">View Processed Records</div>
          <div className="mb-4 flex flex-col gap-3">
            <div className="font-bold  mt-2 text-xl">Select Pay Period</div>
            <div className="text-sm text-gray-500">
              Select the pay period you want to view records for.
            </div>
          </div>

          <div className="flex gap-2">
            <Dropdown
              label="Year"
              items={yearOptions}
              selectedString={selectedYear}
              setSelectedString={setSelectedYear}
            />

            <Dropdown
              label="Month"
              items={monthsOptions}
              selectedString={selectedMonth}
              setSelectedString={setSelectedMonth}
            />
          </div>
        </div>
      </Card>

      <PayRecordsDataTable
        selectedYear={selectedYear}
        selectedMonth={selectedMonth}
      />
    </div>
  );
}

export default PayRecordsPage;
